export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Para"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quantia"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transferir"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transferência entre contas próprias"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transferências dentro da carteira"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["As contas de remetente e destinatário devem ser diferentes"])}
}